var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header_wrap" }, [
        _c(
          "div",
          { staticStyle: { width: "60%" } },
          [
            _c(
              "el-steps",
              {
                staticStyle: { width: "100%" },
                attrs: { "align-center": "", active: 3 }
              },
              [
                _c("el-step", { attrs: { title: "空运信息" } }),
                _vm._v(" "),
                _c("el-step", { attrs: { title: "增值服务" } }),
                _vm._v(" "),
                _c("el-step", { attrs: { title: "托运信息" } }),
                _vm._v(" "),
                _c("el-step", { attrs: { title: "确认委托" } }),
                _vm._v(" "),
                _c("el-step", { attrs: { title: "委托完成" } })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "center_wrap" },
        [
          _c("div", { staticClass: "wrap_l" }, [
            _c("div", {
              staticStyle: { display: "-webkit-flex", "align-items": "center" }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "Item_list" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "header_text" }, [
                _c(
                  "div",
                  {
                    staticClass: "count_center",
                    staticStyle: { "margin-right": "50px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "cangkutit",
                        staticStyle: { color: "red", "font-weight": "bold" }
                      },
                      [_vm._v(_vm._s(_vm.cangkuitem.namec))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "ckttext",
                        staticStyle: { "margin-top": "10px" }
                      },
                      [_vm._v("入仓仓库")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "count_center" }, [
                  _c(
                    "span",
                    {
                      staticClass: "cangkutit",
                      staticStyle: { color: "red", "font-weight": "bold" }
                    },
                    [_vm._v(_vm._s(_vm.PScangkuitem.namec) + "\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "ckttext",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [_vm._v("目的仓库")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "good_count" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "shouMargin" }, [
                          _vm._v(
                            "\n                货物类型：" +
                              _vm._s(_vm.goodsTypeName) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "shouMargin" }, [
                          _vm._v(
                            "\n                总重量：" +
                              _vm._s(_vm.goodsData.weight) +
                              " "
                          ),
                          _c("span", { staticClass: "ckttext" }, [_vm._v("KG")])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "shouMargin" }, [
                          _vm._v("\n                预计到港："),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.arrivaltime,
                                  expression: "arrivaltime"
                                }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.arrivaltime))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.arrivaltime,
                                  expression: "!arrivaltime"
                                }
                              ],
                              staticStyle: { color: "#ccc" }
                            },
                            [
                              _c("i", { staticClass: "el-icon-loading" }),
                              _vm._v("当前暂无到港时间")
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "shouMargin" }, [
                          _vm._v(
                            "\n                总件数：" +
                              _vm._s(_vm.goodsData.piece)
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "ckttext",
                              staticStyle: { "margin-left": "4px" }
                            },
                            [_vm._v("件")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "shouMargin" }, [
                          _vm._v(
                            "\n                总体积：" +
                              _vm._s(_vm.goodsData.cbm)
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "ckttext",
                              staticStyle: { "margin-left": "4px" }
                            },
                            [_vm._v("CBM")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "shouMargin" }, [
                          _vm._v("\n                预计开船："),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.sailingtime,
                                  expression: "sailingtime"
                                }
                              ]
                            },
                            [_vm._v(_vm._s(_vm.sailingtime))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.sailingtime,
                                  expression: "!sailingtime"
                                }
                              ],
                              staticStyle: { color: "#ccc" }
                            },
                            [
                              _c("i", { staticClass: "el-icon-loading" }),
                              _vm._v("当前暂无开船时间")
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-row", [
                    _c("div", {}, [
                      _c(
                        "span",
                        {
                          staticStyle: { float: "left", "margin-top": "10px" }
                        },
                        [_vm._v("货物描述：")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { float: "left", width: "80%" } },
                        _vm._l(_vm.GoodListForAir, function(item, index) {
                          return _c(
                            "el-col",
                            {
                              key: index,
                              staticStyle: { "margin-top": "10px" },
                              attrs: { span: 16 }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(item.goodsname) +
                                    "/" +
                                    _vm._s(item.piece) +
                                    "件/" +
                                    _vm._s(item.weight) +
                                    "KG/" +
                                    _vm._s(item.cbm) +
                                    "CBM"
                                )
                              ])
                            ]
                          )
                        }),
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("feeDetail", {
            attrs: {
              auto_fixed: _vm.auto_fixed,
              allMoreFeeInfo: _vm.allMoreFeeInfo,
              transportFeeForAir: _vm.transportFeeForAir,
              pickFeeForAir: _vm.pickFeeForAir,
              sendFeeForAir: _vm.sendFeeForAir,
              currencyCollection: _vm.currencyCollection,
              calculatePrice: _vm.calculatePrice,
              feeList: _vm.feeList,
              isLastStep: true
            },
            on: { pathToback: _vm.pathToback, pathToNext: _vm.Qdshowcount }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("i18n_Are_your_confirm_order"),
            center: "",
            visible: _vm.dialogTableVisible,
            width: "520px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "showDalog" }, [
            _c("div", { staticClass: "header_text" }, [
              _c(
                "div",
                {
                  staticClass: "count_center",
                  staticStyle: { "margin-right": "50px" }
                },
                [
                  _c(
                    "span",
                    { staticClass: "cangkutit", staticStyle: { color: "red" } },
                    [_vm._v(_vm._s(_vm.cangkuitem.namec))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "ckttext",
                      staticStyle: { "margin-top": "10px" }
                    },
                    [_vm._v("入仓仓库")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "cangkutit",
                  staticStyle: { "margin-right": "50px" }
                },
                [
                  _c("img", {
                    staticStyle: { height: "32px" },
                    attrs: {
                      src: require("../../assets/airOrder.png"),
                      alt: ""
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "count_center" }, [
                _c(
                  "span",
                  { staticClass: "cangkutit", staticStyle: { color: "red" } },
                  [_vm._v(_vm._s(_vm.PScangkuitem.namec) + "\n          ")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "ckttext",
                    staticStyle: { "margin-top": "10px" }
                  },
                  [_vm._v("目的仓库")]
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "goodlist",
                staticStyle: {
                  "margin-top": "40px",
                  width: "100%",
                  float: "left",
                  padding: "0px 40px",
                  "box-sizing": "border-box",
                  "margin-bottom": "30px"
                }
              },
              [
                _c("p", { staticStyle: {} }, [_vm._v("预估费用")]),
                _vm._v(" "),
                _c("div", { staticStyle: { padding: "5px" } }, [
                  _c(
                    "p",
                    {
                      staticStyle: { "font-weight": "bold", color: "#333333" }
                    },
                    [
                      _vm._v(
                        "\n            CNY " +
                          _vm._s(_vm.calculatePrice) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "Qdbtn LR_center",
                staticStyle: { "margin-top": "30px" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "btnstyle",
                    staticStyle: {
                      height: "35px",
                      background: "#ffffff",
                      border: "2px solid #dcdcdc",
                      "border-radius": "35px"
                    },
                    on: {
                      click: function($event) {
                        _vm.dialogTableVisible = false
                      }
                    }
                  },
                  [_vm._v("\n          取消\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btnstyle",
                    staticStyle: {
                      border: "1px solid #5ab53c",
                      "font-size": "30rpx",
                      background: "#ff3939",
                      "border-color": "#ff3939",
                      color: "#ffffff"
                    },
                    on: {
                      click: function($event) {
                        return _vm.pathToNext()
                      }
                    }
                  },
                  [_vm._v("\n          确认委托\n        ")]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "服务条款",
            center: "",
            visible: _vm.policyDialog,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.policyDialog = $event
            }
          }
        },
        [
          _c("div", {}, [
            _c("p", { staticStyle: { "text-align": "end" } }, [
              _vm._v("编号：")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("甲方:亦邦物流在线平台注册用户")]),
            _vm._v(" "),
            _c("p", [_vm._v("统一社会信用代码：")]),
            _vm._v(" "),
            _c("p", [_vm._v("地址：")]),
            _vm._v(" "),
            _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
              _vm._v("（以下统称“甲方”）")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("乙方：亦邦（深圳）国际物流有限公司")]),
            _vm._v(" "),
            _c("p", [_vm._v("统一社会信用代码：91440300717851662C")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        地址：深圳市南山区粤海街道高新区社区科技南路18号深圳湾业园科技生态园12栋裙楼810\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
              _vm._v("（以下统称“乙方”）")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        甲、乙双方经友好协商，根据相关法律和货运行规，由甲方委托乙方代办国际航空/海洋/快递货物出口运输业务及相关单证交接、报关、境内陆路运输、货物跟踪查询、保险等辅助业务事宜达成如下协议：\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第一条 合作内容：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        乙方负责根据甲方指示，为甲方提供国际航空/海洋/快递货物出口运输业务，包括在线海运订舱/空运订舱、报关、海运/空运干线、清关和目的国境内派送/电商物流下单等相关配套服务。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第二条 双方责任：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.1甲方委托乙方承运货物，甲方必须严格遵守中华人民共和国的法律、法令、规定，国际条例和交通部的有关规定。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.2甲方委托乙方出运的货物，需提前订舱，将货物资料传真至乙方，特别是超限、大票、特殊货物，甲方应事先与乙方取得联系，以便乙方安排舱位及确定是否能收运。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("2.3乙方负责提供运价和相关专业咨询。")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.4乙方收到货物后如发现重量和尺码与订舱不符，应立即通知甲方，在得到甲方确认后才可出运。如果因甲方回复迟缓延误运输，所造成的后果由甲方负责。乙方保证在运输过程中为货物提供必要的防护、防雨、封闭空间等措施，确保货物无整箱短缺、无人为原因造成的任何损害。如有上述问题，乙方应承担货损和丢货的赔偿责任，\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.5如果委托乙方代理报关，甲方应整理好报关资料，并对报关资料的准确性和真实性负责。乙方应合理审查甲方提供的单证，如发现错误需及时告知甲方修改。若甲方提供任何错误、不实、过时或不完整或具误导性的资料，由此造成的损失由甲方自行承担，乙方不承担任何相关责任。若由于乙方责任造成报关单证错误或遗失，乙方须依法向甲方承担责任。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "2.6乙方收到货物后及时安排出运，并将相关单据完整及时回传给甲方。"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.7若乙方因各种不可抗力原因无法按预定时间出运，应及时书面或者电话通知甲方，并按甲方的合理要求采取跟进措施。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.8对由于承运人或不可抗力因素造成货物延误交货、货损等事故，按航空公司运单及相关国际航空运输公约处理善后事宜，乙方不承担责任，但应积极协助甲方解决。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.9乙方在甲方授权范围内，作为运输代理人，根据甲方合法合规且无损乙方利益的指示和要求代理甲方处理相关事宜的后果由甲方承担。乙方超越授权范围或未按照甲方指示或要求处理的相关事宜，由乙方承担全部责任。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.10乙方负责根据甲方托运单内容将甲方的货物运输至甲方的指定地点，交付甲方指定的国际运输承运公司或收货人。乙方在甲方指定装货地点装货完毕签收之时起至运抵甲方指定收货地由甲方指定的国际运输承运公司或收货人签收之时止，为乙方责任区间，由乙方负责。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.11甲方有权要求乙方按委托指令将货物运送到目的地，并有权知悉业务进展情况及服务过程；在未办理提货、发货手续之前，甲方有权变更或取消委托内容，由此产生的合理费用由甲方承担。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        2.12如果甲方发运的物品因甲方或与货物自身相关原因被起运港或目的港海关、相关政府部门或其他执法部门查验、扣货、销毁等，相关损失由甲方自行承担。因此给乙方造成损失的，甲方应赔偿乙方损失。如非因甲方自身原因造成前述情况的，乙方应及时通知甲方，并协助甲方积极处理，如为乙方或乙方雇佣人员或委托的第三方造成的，则乙方应向甲方承担赔偿责任。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第三条 货物交接具体办法：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "3.1甲方发货前需真实完整地填写国际货物托运书，传真或E-MAIL给乙方。"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "3.2乙方联系甲方确定具体的收货时间和地址或由甲方亲自送货入仓。"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        3.3乙方根据甲方提供的报关资料制单（运单的重量以货站的核重为准）、报关。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "3.4乙方应在完成交货至最终收货仓后48小时内提供签收回执给甲方。"
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第四条 收费：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        有关费用结算，甲方应当按双方邮件、或者书面约定的各项费用及时足额支付。乙方向甲方收取的费用，以运输前确认为主，乙方保留根据市场行情进行调整资费的权利，但必须邮件、或者书面通知甲方,并得到甲方的书面确认回复。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第五条 结算：")]),
            _vm._v(" "),
            _c("p", [_vm._v("5.1双方约定采取下列第一种作为运费结算方式：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        第一种方式：票结。乙方每次账单确认后第一时间将账单提供给甲方进行确认，如收到后有异议须在三个工作日内反馈，超过三个工作日视为确认，核对无误后，甲方须于五个工作日向乙方结算，运费按要求超过时间未付的，乙方可采取必要途径向甲方追讨欠款，并有权追究甲方违约责任。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        第二种方式：设定最高限额的月结。\n        结算期为每月1日至月末最后一天，当月最高限额为人民币100,000元，大写人民币拾万元整。如当月内甲方应付乙方的费用达到最高额度时，甲方应预先支付人民币100,000元，且在10个工作日内将此金额支付到乙方指定账户，因无理由拖欠付款产生的货物滞留等相关法律、经济责任由甲方承担。对剩余未付部份或当月未达到最高限额时按如下操作：\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        A、乙方于每月5日前提供上月1号至月末最后一天的业务账单给甲方，甲方在收到账单之日起3个工作日内完成确认工作，以书面形式通知乙方；双方确认无误后，乙方向甲方出具正式税务发票及相关材料；甲方于收到发票起\n        10个工作日内将上月1号至月末最后一天运费汇入乙方指定账户。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        B.\n        如甲方对费用有争议，须在收到对账单后3个工作日内书面形式通知乙方，双方必须在该票业务的次月25日前（以甲方提供货物托运输的日期作为该业务的产生日期）协商确定，并于商定的付款日期内付款，以免影响次月运作；如甲方在收到对账单后3个工作日内未提出异议视为对账单所列费用已认可。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        5.2甲方应在协定时间（如遇假期顺延）内支付款项，如逾期不付，则乙方有权按拖欠时间每日加收总款项的5‰的滞纳金。甲方逾期付款超过45天以上的，乙方有权留置甲方交付的货物及与货物相关的单证（包括运输单证），责任由甲方承担。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "5.3运费结算方式为：现金，支票，转帐，汇至乙方指定帐户里。"
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第六条 知识产权:")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        6.1乙方拥有双方合作中的电子商务运营系统及其操作规范的所有知识产权，由乙方提供的包括不限于项目运营信息系统、仓储物流的有关规范、流程、图表、说明等文字知识产权属乙方独自所有，甲方不得利用技术手段予以篡改或侵犯；\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        6.2任意一方需在得到对方的书面授权后，方可使用对方的商标、标识。任意一方并不能因为本合同自动获得对方商标、标识的使用权。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第七条 保密责任")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        7.1双方对本合同以及在履行本合同中接触到的双方的经营情况、商业信息、客户名单、技术资料等将严格保密，非经对方事先书面同意和合同正常履行之需，不得向第三方泄漏。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        7.2甲方承诺不披露或公开费率、条款和价格方案等，除非法律强制要求对此做出披露或公开。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("7.3双方应保证本方雇员履行上述义务。")]),
            _vm._v(" "),
            _c("p", [_vm._v("7.4本义务不因本合同的解除、终止、撤消而失效。")]),
            _vm._v(" "),
            _c("p", [_vm._v("第八条 违约责任：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        8.1甲方未按合同约定的期限向乙方支付费用，应按照实际违约天数，每日向乙方支付未付款金额的__0.05_%作为违约金。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        8.2因甲方提供资料不齐全而导致乙方无法完成送达任务，损失完全由甲方承担;乙方在运输过程中如果发现甲方所提供的收货人联系方式有误，应及时与甲方联系寻求解决方案，因此导致乙方未能按照约定时间交付货物，乙方不负责任，对乙方造成损失的，甲方应负责赔偿。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        8.3甲方如隐瞒货物属性，由此给乙方或第三人造成损失的，由甲方负全部赔偿责任。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("8.4其他违反合同约定行为。")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        注：违反本合同约定的，违约方除需赔偿损失外，还应承担守约方包括但不限于诉讼费、律师费、交通费等合理损失。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第九条 协议变更与解除：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        9.1本协议生效后，未经对方同意，任何一方不得擅自变更或解除本协议。需要变更或解除本协议时，应经双方协商一致，达成书面协议。未签署另行达成的书面协议前，本协议条款仍然有效。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        9.2甲乙双方任何一方有违反本协议条款时，构成根本违约时，另一方有权解除本协议，违约一方应于获取通知后的七个工作日内给另一方结算所有应付（应收）款项，并承担相应违约责任。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第十条 争议解决：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "10.1本协议在执行过程中如发生争议，适用中华人民共和国法律解决。"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        10.2本协议在执行过程中发生争议时，双方可协商解决；不能协商解决的，可向乙方所在地人民法院提起诉讼。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        10.3在上述磋商或诉讼期间，双方应继续履行争议部分之外的本合同项下各自义务。\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第十一条 协议生效 ：")]),
            _vm._v(" "),
            _c("p", [
              _vm._v("11.1本协议用户在亦邦物流在线平台勾选同意后生效。")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("第十二条 其他约定：")]),
            _vm._v(" "),
            _c("p", { staticStyle: { "margin-bottom": "30px" } }, [
              _vm._v("12.1本协议未尽事宜，由双方协商解决；")
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "margin-bottom": "20px" } }, [
              _vm._v("（以下无正文，为签署页）")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("甲方：亦邦物流在线平台注册用户")]),
            _vm._v(" "),
            _c("p", [_vm._v("乙方：亦邦（深圳）国际物流有限公司")]),
            _vm._v(" "),
            _c("p", [_vm._v("签订地点：深圳")])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "-webkit-flex",
          "align-items": "center",
          "margin-bottom": "20px"
        }
      },
      [
        _c("img", {
          attrs: { src: require("../../assets/weituo.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "tittype" }, [_vm._v("订单信息")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "cangkutit", staticStyle: { "margin-right": "50px" } },
      [
        _c("img", {
          staticStyle: { width: "65px" },
          attrs: { src: require("../../assets/airOrder.png"), alt: "" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6611c150", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6611c150","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/airOrder/AirConfirmPage.vue
// module id = null
// module chunks = 